/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesretry1Inputs */

const en_filesretry1 = /** @type {(inputs: Filesretry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const pt_filesretry1 = /** @type {(inputs: Filesretry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Filesretry1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesretry1 = /** @type {((inputs?: Filesretry1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesretry1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesretry1(inputs)
	return pt_filesretry1(inputs)
});
export { filesretry1 as "filesRetry" }